/* eslint-disable max-lines */
/* eslint-disable no-negated-condition */
/* global window */
import React from 'react';
import { compose } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import withRouter from 'HOCs/withRouter';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withFeatureFlag as withLQFeatureFlag } from 'LaquesisEOL/withFeatureFlag';
import ImageGallery from 'Components/ImageGallery/ImageGallery';
import AsyncItemLeadForm from '../components/ItemLeadForm/AsyncItemLeadForm';
import RenderActionButtons from './RenderActionButtons/RenderActionButtons';
import AdOverview from './AdAttributes/AdOverview.desktop';
import Features from './Features/Features';
import TechnicalReport from './TechnicalReport/TechnicalReport';
import AsyncRelatedAdsMX from '../components/RelatedAdsMX/AsyncRelatedAdsMX';
import InspectionReport from './InspectionReport/InspectionReport';
import AdDescription from './AdDescription/AdDescription.desktop';
import { getItemPanelsFromMetadata, isCocoFofoUser, getIsStoreInspectedCar, getThankYouWidgetProps, getInspectionReportSections, createWhatsAppLink, getMappingPriortized } from 'Helpers/item';
import {
    DYNAMIC_PANELS,
    INSPECTION_INFO_STATUS,
    ITEM_FULL_SCREEN_HASH,
    NAVBAR_ITEMS,
    HEADER_OFFSET,
    USERFORM_STATES,
    BREADCRUMB_HEIGHT,
    LEAD_GEN_SOURCES,
    LEAD_HASH,
    FILTER_INSPECTION_REPORT,
    LQ_SHORTLIST_FEATURE,
    WHATSAPP,
    LIST_OF_CITIES,
    CTA_CONFIGS_MAP,
    CTA_MAP
} from 'Constants/items';
import { InView } from 'react-intersection-observer';
import { isEmpty } from 'Helpers/objects';
import css from './AdpvMX.desktop.scss';
import ReactObserver from 'Components/ReactObserver/ReactObserver';
import { setItem as setSessionItem, getItem as getSessionItem } from 'Helpers/sessionStorage';
import { EXPONEA_EVENT_TO_KEY_MAP } from 'Constants/exponeaLeads';
import SellerInfo from 'Components/SellerInfo/SellerInfo';
import NavBar from './NavBar/NavBar';
import ReactObserverWrapper from '../components/ReactObserverWrapper/ReactObserverWrapper';
import { ADPV_EVENTS, LEAD_FORM_SUBMIT, FLOW_STEP, FLOW_TYPE, LEAD_IMPRESSION_FIELD_NAMES } from 'Constants/tracking';
import withConfig from 'HOCs/withConfig/withConfig';
import { default as ReportAdMX } from './ReportAd/ReportAd';
import ReportAd from '../components/ReportAd/ReportAd';
import VasTagsClass from './VasTagsCla/VasTagsCla';
import BrandPromise from 'Components/BrandPromise/BrandPromise';
import BrandPromiseCoco from 'Components/BrandPromiseCoco/BrandPromise';
import PriceCard from './PriceCard/PriceCard.APP_TARGET';
import GalleryNavigationTiles from './GalleryNavigationTiles/GalleryNavigationTiles';

import CFWidgetAsync from './CFWidgetModule/CFWidgetAsync';
import SwapWidgetAsync from './SwapWidget/SwapWidgetAsync';
import { handleScrollToTargetAdjusted } from 'Helpers/elementScroll';

import { EXPONEA_EVENT_TYPES } from 'Constants/exponeaLeads';
import { BLACKBACKGROUND2, MONETIZATIONDARK1, WHITE_TEXT } from 'Constants/colors';

import GalleryNavOverlayAsync from './GalleryNavOverlay/GalleryNavOverlayAsync';
import { selectAdpvGalleryImages } from 'Selectors/items';
import AdBasicAttributes from '../adpvMXComponents/AdAttributes/AdBasicAttributes.desktop';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { MODE, WEBP_SVG_TYPE, XX } from 'Constants/images';
import { LayoutHelper } from 'olx-autos-landing-page';
import { adStatus } from 'Constants/adStatus';
import Auth from '../../../Auth';
import ContactInfo from '../components/ProfileCard/ContactInfo.desktop';
import withMessage from 'HOCs/withMessage/withMessage';
import { Overlay, Button } from 'panamera-react-ui';
import ThankYouWidget from 'Components/ThankYouWidget/ThankYouWidget';
import { leadFormConfigSelector } from 'Selectors/leadForm';
import { getLeadFormName, checkIfLoginMandatory, mapActiontoHash, mapHashToAction } from 'Helpers/leadForm';
import CookieManager from 'Helpers/cookies';
import NewIconButton from 'Components/ThematicNewIconButton/ThematicNewIconButton';
import { getCampaignParams } from 'Autos/helpers/helpers';
import MeetingBanner from '../components/MeetingBanner/MeetingBanner';
import IntentButtons from '../../MyZone/CTA/IntentButtons/AsyncIntentButtons';
import { setOrigin } from 'Actions/track';
import { TrackerOrigins } from 'Components/TrackerProvider/TrackerProvider';
import withFeatureFlags from 'HOCs/withFeatureFlags/withFeatureFlags';
import { getCarReserveStatus, resetReserveState } from 'Actions/reserve';
import { getCarIdSelector } from 'Selectors/reserve';
import _setLoginModalState from 'Actions/setLoginModalState';
import { setLeadFormV2State as setLeadFormV2StateAction,
    resetLeadFormV2FetchConfigState
} from 'Actions/leadFormV2';
import StickyWhatsappButton from 'Autos/components/StickyWhatsappButton/StickyWhatsappButton';
import { USER_TYPE } from 'Constants/users';
import { getCtaName } from 'Helpers/leadFormV2';
import TradeInFormAsync from 'Components/CrossSell/TradeInForm/TradeInFormAsync';
import { getTrackingAttributes } from 'Helpers/priceCardTabs';
import { checkUserMembership } from 'Helpers/premiumUser';
import withVwo from 'HOCs/withVwo/withVwo';
import { AI_VIDEO_ADS_CAMPAIGN_ID } from 'Constants/constants';
import AsyncRelatedArticles from '../components/RelatedArticles/AsyncRelatedArticles';

export const saveToSessionStorage = (item, userType, isOlxmobbi, locationMapper) => {
    const dataItem = item;

    const vasTags = dataItem?.value_added_services?.map(service => {
        return service.key;
    });
    const user_type = userType;
    let adpvData = { ...dataItem, user_type, vasTags };

    let keySessionStorage = 'recentActivity';

    if (!isOlxmobbi || isOlxmobbi == undefined) {
        keySessionStorage = 'recentActivityOlx';
    }
    // eslint-disable-next-line no-undef
    const sessionStorageData = sessionStorage.getItem(keySessionStorage);

    const maxDataCount = 10;

    const locationsResolvedMapping = {
        COUNTRY: { idKey: 'COUNTRY_id', nameKey: 'COUNTRY_id' },
        STATE: { idKey: 'ADMIN_LEVEL_1_id', nameKey: 'ADMIN_LEVEL_1_name' },
        CITY: { idKey: 'ADMIN_LEVEL_3_id', nameKey: 'ADMIN_LEVEL_3_name' },
        NEIGHBOURHOOD: { idKey: 'SUBLOCALITY_LEVEL_1_id', nameKey: 'SUBLOCALITY_LEVEL_1_name' }
    };

    const locationMapping = locationMapper;

    const locationsResolvedMapper = data => {
        const locationsResolvedData = {};

        data?.locations?.forEach(location => {
            location?.tree?.forEach(treeItem => {
                if (treeItem.type) {
                    const { idKey, nameKey } = locationsResolvedMapping[treeItem.type];

                    locationsResolvedData[idKey] = treeItem?.id;
                    locationsResolvedData[nameKey] = treeItem?.name;
                }
            });
        });
        return locationsResolvedData;
    };

    if (sessionStorageData && adpvData.metadata !== undefined && adpvData.category_id == '198') {
        let existingData = JSON.parse(sessionStorageData);
        const locationsResolved = locationsResolvedMapper(adpvData.metadata);
        const mappingPrioritized = getMappingPriortized(locationsResolved, locationMapping);

        mappingPrioritized?.prioritizedLevels?.reverse();

        adpvData = { ...adpvData, locations_resolved: mappingPrioritized };

        existingData = existingData.filter(item => item.id !== adpvData.id);
        existingData.unshift(adpvData);
        existingData = existingData.slice(0, maxDataCount);
        // eslint-disable-next-line no-undef
        sessionStorage.setItem(keySessionStorage, JSON.stringify(existingData));
    }
    else if (adpvData.metadata !== undefined && adpvData.category_id == '198') {
        const locationsResolved = locationsResolvedMapper(adpvData.metadata);
        const mappingPrioritized = getMappingPriortized(locationsResolved, locationMapping);

        mappingPrioritized?.prioritizedLevels?.reverse();

        adpvData = { ...adpvData, locations_resolved: mappingPrioritized };

        // eslint-disable-next-line no-undef
        sessionStorage.setItem(keySessionStorage, JSON.stringify([adpvData]));
    }
};

export const getAdDetails = (carId, itemId, item, parameters, user) => {
    const { year, make, model, basicInfo, variant } = item?.inspectionDetails || {};

    return {
        b2c_car_id: carId || item.inspection_info.carId,
        b2c_store_id: user.id || user.name,
        b2c_year: year || parameters.find(e => e.key === 'm_year').value_name,
        b2c_ad_id: itemId,
        b2c_make: make || parameters.find(e => e.key === 'make').value_name,
        b2c_model: model,
        b2c_trim: variant || parameters.find(e => e.key === 'm_tipe_variant').value_name,
        b2c_mileage: basicInfo.parameters.find(e => e.key === 'mileage').value,
        b2c_fuel_type: basicInfo.parameters.find(e => e.key === 'fuel').value,
        b2c_car_listing_price: item.price.value.display
    };
};
export class AdpvMX extends React.PureComponent {
    static propTypes = {
        item: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        isMyItem: PropTypes.bool.isRequired,
        isItemOutdated: PropTypes.bool,
        trackImageTap: PropTypes.func,
        getTrackingInfo: PropTypes.func.isRequired,
        trackImagePagination: PropTypes.func,
        onTrack: PropTypes.func.isRequired,
        onMessageSend: PropTypes.func,
        sendChatMessage: PropTypes.func,
        toggleFirstTimeUserTips: PropTypes.func.isRequired,
        tipsInitiationPoint: PropTypes.string,
        leadFormName: PropTypes.string,
        AsyncleadFormName: PropTypes.string,
        leadFormFlow: PropTypes.func,
        onClickReport: PropTypes.func.isRequired,
        isFullItem: PropTypes.bool.isRequired,
        itemId: PropTypes.string,
        parameters: PropTypes.array,
        loggedUser: PropTypes.shape({
            id: PropTypes.string
        }),
        recordItemImpressions: PropTypes.func.isRequired,
        getMonetizerCard: PropTypes.func.isRequired,
        getLimitsCard: PropTypes.func.isRequired,
        config: PropTypes.shape({
            get: PropTypes.func.isRequired
        }).isRequired,
        intl: PropTypes.shape({
            formatMessage: PropTypes.func.isRequired
        }).isRequired,
        openModal: PropTypes.func.isRequired,
        openGalleryOverlay: PropTypes.func.isRequired,
        isGalleryOverlayOpened: PropTypes.bool,
        closeGalleryOverlay: PropTypes.func,
        mainGalleryImages: PropTypes.arrayOf(PropTypes.object),
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
            hash: PropTypes.string
        }).isRequired,
        router: PropTypes.shape({
            push: PropTypes.func.isRequired
        }).isRequired,
        params: PropTypes.object.isRequired,
        isSpinCarEnabled: PropTypes.bool,
        showNewDesign: PropTypes.bool,
        onViewRelatedAd: PropTypes.func,
        onSetFireMakeOffer: PropTypes.func,
        fireMakeOffer: PropTypes.bool,
        renderBanners: PropTypes.func,
        leadFormConfigData: PropTypes.object,
        showIvrNumberOnAdpv: PropTypes.bool,
        showRequestCallbackOnAdpv: PropTypes.bool,
        showInterestOnAdpv: PropTypes.bool,
        showStoreTestdriveOnAdpv: PropTypes.bool,
        showStoreVisitOnAdpv: PropTypes.bool,
        showChatOnAdpv: PropTypes.bool,
        showCallOnAdpv: PropTypes.bool,
        showOfferOnAdpv: PropTypes.bool,
        showReserve: PropTypes.bool,
        showWhatsAppCTA: PropTypes.bool,
        landingURL: PropTypes.string,
        trackOrigin: PropTypes.string,
        trackSelectFrom: PropTypes.string,
        setOriginTrack: PropTypes.func,
        setLeadFormHash: PropTypes.func,
        openLead: PropTypes.func,
        closeLead: PropTypes.func,
        leadHash: PropTypes.string,
        isMissedReserveOpened: PropTypes.bool,
        closeMissedReserve: PropTypes.func,
        getCarReserveStatus: PropTypes.func,
        carId: PropTypes.string,
        reserve: PropTypes.object,
        resetReserveStateAction: PropTypes.func,
        setLoginModalState: PropTypes.func.isRequired,
        isReserveFlow: PropTypes.bool,
        setLeadFormV2State: PropTypes.func,
        adpvTxnRevamp: PropTypes.bool,
        featureFlag: PropTypes.string,
        resetLeadFormV2FetchConfigState: PropTypes.func,
        isLeadFormV2ConfigCached: PropTypes.bool,
        fetchConfig: PropTypes.bool,
        isOlxMobbi: PropTypes.bool,
        vwoClientInstance: PropTypes.shape({
            activate: PropTypes.func.isRequired,
            track: PropTypes.func.isRequired
        }),
        isShowCoachMark: PropTypes.bool,
        onCloseMarkCoach: PropTypes.func,
        isShowReservationButton: PropTypes.bool,
        isItemReserved: PropTypes.bool,
        escrowDetails: PropTypes.object,
        escrowTrack: PropTypes.func,
        renderBookingModal: PropTypes.func
    };

    static defaultProps = {
        isFullItem: false,
        leadFormName: '',
        AsyncleadFormName: '',
        leadFormFlow: () => { },
        trackImageTap: () => { },
        trackImagePagination: () => { },
        renderbanner: () => { },
        variant: 'a',
        mainGalleryImages: [],
        leadFormConfigData: {},
        showRequestCallbackOnAdpv: false,
        showInterestOnAdpv: false,
        showChatOnAdpv: false,
        showCallOnAdpv: false,
        showOfferOnAdpv: false,
        showStoreTestdriveOnAdpv: false,
        showIvrNumberOnAdpv: false,
        showReserve: false,
        setLoginModalState: () => {},
        isReserveFlow: false,
        adpvTxnRevamp: false,
        featureFlag: '',
        vwoClientInstance: {
            track: () => {},
            activate: () => {}
        },
        renderBookingModal: () => {}
    };

    constructor(props) {
        super(props);

        this.overviewRef = React.createRef();
        this.technicalReportRef = React.createRef();
        this.inspectionReportRef = React.createRef();
        this.featuresPanelRef = React.createRef();
        this.consumerFinancingPanelRef = React.createRef();
        this.swapWidgetRef = React.createRef();

        this.user = props.user;
        this.userType = this.user?.dealer?.car?.dealer_type;
        this.isCocoFofoUser = isCocoFofoUser(this.userType);
        this.isAutosFlow = props.config.get('isAutosFlow');
        this.showCLAIntentCTAs = props.config.get('olxAutos', 'showCLAIntentCTAs');
        this.showAdpIntentCTAs = props.config.get('olxAutos', 'showAdpIntentCTAs') || (this.isCocoFofoUser && this.showCLAIntentCTAs);

        this.adpvConfig = props.config.get('adpvAuto');
        this.panels = getItemPanelsFromMetadata(props.item);
        this.state = {
            basicInfoInView: false,
            selectedTabId: 0,
            isNewLeadGenFormOpen: false,
            selectedImgIdx: 0,
            showThankYou: false,
            AsyncleadFormName: '',
            cfWidgetInView: false,
            leadFormAction: this.showAdpIntentCTAs ? [''] : ['onInterestedTap'],
            isLoggedIn: Auth?.isLoggedIn(),
            isLoginMandatory: false,
            isExchangeCollapsed: true,
            showTradeInForm: false
        };
        this.inViewTabs = [];
        this.carExtendedInspectedTagUri = props.config.get('adpvAuto', 'carExtendedInspectedTagUri');
        this.enableEmiFeature = props.config.get('enableEmiFeature');
        this.showNewLeadForm = this.props.config.get('olxAutos', 'showNewLeadForm');
        this.showWhatsApp = this.props.config.get('adpvAuto', 'showWhatsApp');
        this.whatsAppNumber = this.props.config.get('adpvAuto', 'whatsAppNumber');
        this.whatsAppLink = createWhatsAppLink(this.props.item, this.props.config, this.props.location.pathname, this.props.intl);
    }

    componentDidMount() {
        this.props.setOriginTrack(TrackerOrigins.ITEM_PAGE);
        if (this.props.location.hash === LEAD_HASH.NOTIFYME_HASH) {
            const actionToSet = mapHashToAction(this.props.location.hash);

            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({ leadFormAction: [actionToSet] }, () => {
                this.props.setLeadFormHash(this.props.location.hash);
            });
        }
        if (this.props.isMissedReserveOpened && !this.state.showThankYou) {
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState(
                ({ showThankYou }) => ({ showThankYou: !showThankYou })
            );
        }
        if (!this.showNewLeadForm) {
            this.getLeadForm();
            this.checkIfLoginMandatory();
        }
        if (this.showWhatsApp && this.whatsAppLink) {
            this.trackLeadImpression(this.props.onTrack, LEAD_IMPRESSION_FIELD_NAMES.WHATSAPP, { flow_type: FLOW_TYPE.ADPAGE });
        }

        if (this.showNewLeadForm && !this.props.isLeadFormV2ConfigCached) {
            this.props.setLeadFormV2State({ show: true, fetchConfig: true });
        }
        saveToSessionStorage(this.props?.item, this.props?.user?.dealer?.car?.dealer_type, this.props.config.get('olxAutos', 'isMXCL'), this.props.config.get('locationMapping'));

        if (this.props.isShowCoachMark) {
            // eslint-disable-next-line no-undef, no-magic-numbers
            const scrollVal = this.props.isOlxMobbi ? 400 : 1000;

            window.scrollTo({ top: scrollVal, behavior: 'smooth' });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        saveToSessionStorage(this.props?.item, this.props?.user?.dealer?.car?.dealer_type, this.props.config.get('olxAutos', 'isMXCL'), this.props.config.get('locationMapping'));
        const isLeadStateChage = prevState.leadFormAction !== this.state.leadFormAction;
        const isLeadPropChange = !prevProps.leadFormConfigData.form_config && this.props.leadFormConfigData.form_config;

        if (!this.showNewLeadForm && (isLeadStateChage || isLeadPropChange)) {
            this.getLeadForm(this.props);
            this.checkIfLoginMandatory(this.props);
        }
        if ((prevProps.leadHash != this.props.leadHash) && this.props.leadHash) {
            this.props.openLead();
            if (this.showNewLeadForm) {
                this.openLeadFormV2();
            }
            else {
                this.toggleNewLeadGenForm();
            }
        }
        if (this.props.isReserveFlow
            && !this.props.reserve?.isFetching
            && !this.props.reserve?.isSuccess
            && !this.props.reserve?.isError
            && this.props.item?.id) {
            this.props.getCarReserveStatus(this.props.item?.id);
        }
        else if (this.props.isReserveFlow && Auth?.isLoggedIn() && !this.state.isLoggedIn) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(({ isLoggedIn: Auth?.isLoggedIn() }), () => {
                this.props.getCarReserveStatus(this.props.item?.id);
            });
        }

        if (this.props.isLeadFormV2ConfigCached && this.props.fetchConfig) {
            this.props.resetLeadFormV2FetchConfigState();
        }
    }

    componentWillUnmount() {
        this.props.resetReserveStateAction();
    }

    trackLeadImpression(onTrack, fieldName, trackProps = {}) {
        onTrack(ADPV_EVENTS.VIEW_LEAD_IMPRESSION, {
            field_name: fieldName,
            select_from: TrackerOrigins.ITEM_PAGE,
            ...trackProps
        });
    }

    setLeadFormType = (action, callback) => {
        this.setState({ leadFormAction: [action] }, () => {
            const hashToAdd = mapActiontoHash(action);

            this.props.setLeadFormHash(hashToAdd);
            if (this.showNewLeadForm) {
                // eslint-disable-next-line callback-return
                callback?.();
            }
            else {
                this.checkIfLoginMandatory(this.props, callback);
            }
        });
    };

    getLeadForm = (props = this.props) => {
        const { form_config } = props.leadFormConfigData;

        if (form_config) {
            const AsyncleadFormName = getLeadFormName({
                leadFormActions: this.state.leadFormAction,
                form_config
            });

            this.setState({ AsyncleadFormName });
        }
    };

    checkIfLoginMandatory = (props = this.props, callback) => {
        const { form_config } = props.leadFormConfigData;

        if (form_config) {
            const isLoginMandatory = checkIfLoginMandatory(
                {
                    leadFormActions: this.state.leadFormAction,
                    form_config
                }
            );

            this.setState({ isLoginMandatory }, () => {
                if (callback) {
                    // eslint-disable-next-line callback-return
                    callback();
                }
            });
        }
    }

    setMainGalleryImgIdx = imgUrl => {
        const imgIdx = this.props.mainGalleryImages.findIndex(({ url }) => url === imgUrl);

        if (imgIdx >= 0) {
            this.setState({ selectedImgIdx: imgIdx });
        }
    }

    handleTagTap = (tabId, offset = 0) => {
        if (this.state.selectedTabId === tabId) {
            return;
        }

        let tappedTab = DYNAMIC_PANELS.OVERVIEW;
        let flowType;
        let flowStep;

        switch (Number(tabId)) {
            case NAVBAR_ITEMS.OVERVIEW:
                handleScrollToTargetAdjusted(this.overviewRef, offset);
                break;
            case NAVBAR_ITEMS.INSPECTION_REPORT:
                handleScrollToTargetAdjusted(this.inspectionReportRef, offset);
                tappedTab = DYNAMIC_PANELS.INSPECTION_REPORT;
                break;
            case NAVBAR_ITEMS.TECHNICAL_REPORT:
                handleScrollToTargetAdjusted(this.technicalReportRef, offset);
                tappedTab = DYNAMIC_PANELS.TECHNICAL_REPORT;
                break;
            case NAVBAR_ITEMS.FEATURES:
                handleScrollToTargetAdjusted(this.featuresPanelRef, offset);
                tappedTab = DYNAMIC_PANELS.FEATURES;
                break;
            case NAVBAR_ITEMS.CONSUMER_FINANCING:
                handleScrollToTargetAdjusted(this.consumerFinancingPanelRef, offset);
                tappedTab = DYNAMIC_PANELS.CONSUMER_FINANCING;
                flowStep = FLOW_STEP.FINANCE_LINK;
                flowType = FLOW_TYPE.ADPAGE;
                break;
            case NAVBAR_ITEMS.SWAP_WIDGET:
                handleScrollToTargetAdjusted(this.swapWidgetRef, offset);
                break;
        }
        let customProperty = { chosen_option: tappedTab };

        if (flowStep) {
            customProperty = { ...customProperty, flow_step: flowStep };
        }

        if (flowType) {
            customProperty = { ...customProperty, flow_type: flowType };
        }

        this.setState({
            selectedTabId: tabId
        });

        this.props.onTrack(ADPV_EVENTS.ADPAGE_TOPBAR, customProperty);
    }

    handleTapOnConsumerFinancingLink = () => {
        this.handleTagTap(NAVBAR_ITEMS.CONSUMER_FINANCING);
    }

    onSwapWidgetView = inView => {
        if (inView) {
            this.props.onTrack(ADPV_EVENTS.VIEW_LEAD_IMPRESSION, {
                field_name: LEAD_GEN_SOURCES.EXCHANGE_CAR,
                select_from: TrackerOrigins.ITEM_PAGE
            });
        }
    }

    handleConsumerFinanceWidget = inView => {
        if (inView && !this.state.cfWidgetInView) {
            this.setState({ cfWidgetInView: inView });
        }
    }

    renderIRReport = () => {
        const { item, recordItemImpressions, trackImagePagination } = this.props;
        const damageReport = item.inspectionDetails && item.inspectionDetails.damageReport;
        const filteredDamageReport = FILTER_INSPECTION_REPORT ? getInspectionReportSections(item?.inspectionDetails?.damageReport) : damageReport;

        const showPanel = this.panels.includes(DYNAMIC_PANELS.INSPECTION_REPORT);

        return (
            showPanel && !isEmpty(filteredDamageReport?.values)
            && <div ref={ this.inspectionReportRef } className={ css.whiteCard }>
                <ReactObserverWrapper
                    navBarItemId={ NAVBAR_ITEMS.INSPECTION_REPORT }
                    impression={ DYNAMIC_PANELS.INSPECTION_REPORT }
                    recordItemImpressions={ recordItemImpressions }
                    setSelectedTabId={ this.setSelectedTabId }
                >
                    <InspectionReport
                        damageReport={ filteredDamageReport }
                        onTrack={ this.props.onTrack }
                        onHandleImgTap={ this.props.trackImageTap }
                        trackImagePagination={ trackImagePagination }
                        filterInspection={ FILTER_INSPECTION_REPORT }
                    />
                </ReactObserverWrapper>
            </div>
        );
    }

    renderExchangeBanner = () => {
        const { intl, config } = this.props;
        const { isExchangeCollapsed } = this.state;
        const staticAssetUrl = config.get('staticAssets');

        return (<div className={ css.exchangeContainer }>
            <div className={ css.leftSide }>
                <div className={ css.title }>{intl.formatMessage({ id: 'exchangeTitle' })}</div>
                <div className={ css.subtitle }>{intl.formatMessage({ id: 'exchangeSubtitle' })}</div>

                {/* eslint-disable-next-line react/jsx-no-bind */}
                <div className={ css.collapseContainer } onClick={ () => this.setState({ isExchangeCollapsed: !isExchangeCollapsed }) }>
                    <div className={ classNames(css.collapsible,
                        {
                            [css.collapsed]: !isExchangeCollapsed
                        }) }>
                        <span>{intl.formatMessage({ id: 'limitedService' })}</span>
                        {isExchangeCollapsed && <span className={ css.showMore }>{intl.formatMessage({ id: 'exchangeShowMore' })}</span>}
                        {!isExchangeCollapsed && <div className={ css.collapsedContent }>
                            <div className={ css.cities }>
                                <div className={ css.collapsedTitle }>{intl.formatMessage({ id: 'listOfCities' })}</div>
                                <div className={ css.collapsedSubtitle }>{LIST_OF_CITIES}</div>
                            </div>
                            <div className={ css.showMore }>{intl.formatMessage({ id: 'showLess' })}</div>
                        </div>}
                    </div>
                </div>
                <Button
                    type="primary"
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={ () => this.setState({ showTradeInForm: true }) }
                    data-aut-id="trade-in-cta"
                    className={ css.exchangeBtn }
                    fixed>
                    {intl.formatMessage({ id: 'clickHere' })}
                </Button>
            </div>
            <img src={ `${staticAssetUrl}/olxid/autos/exchange/exchange-banner.svg` } />
        </div>);
    }

    renderTechnicalReportPanel = () => {
        const { item, onTrack, recordItemImpressions } = this.props;
        const technicalReport = item.inspectionDetails && item.inspectionDetails.technicalReport;
        const showTechnicalReport = technicalReport && technicalReport.values && technicalReport.values.length > 0;

        return (this.panels.includes(DYNAMIC_PANELS.TECHNICAL_REPORT)
            && !isEmpty(technicalReport)
            && showTechnicalReport
            && <div ref={ this.technicalReportRef } className={ css.whiteCard }>
                <ReactObserverWrapper
                    navBarItemId={ NAVBAR_ITEMS.TECHNICAL_REPORT }
                    impression={ DYNAMIC_PANELS.TECHNICAL_REPORT }
                    recordItemImpressions={ recordItemImpressions }
                    setSelectedTabId={ this.setSelectedTabId } >
                    <TechnicalReport
                        itemTechnicalReport={ technicalReport }
                        itemId={ item.id }
                        onTrack={ onTrack }
                    />
                </ReactObserverWrapper>
            </div>
        );
    }

    renderFeaturesPanel = () => {
        const { item, recordItemImpressions, onTrack } = this.props;
        const features = item.inspectionDetails && item.inspectionDetails.specialFeaturesSummary;

        return (this.panels.includes(DYNAMIC_PANELS.FEATURES)
            && features
            && features.length > 0
            && <div ref={ this.featuresPanelRef } className={ css.whiteCard }>
                <ReactObserverWrapper
                    navBarItemId={ NAVBAR_ITEMS.FEATURES }
                    impression={ DYNAMIC_PANELS.FEATURES }
                    recordItemImpressions={ recordItemImpressions }
                    setSelectedTabId={ this.setSelectedTabId } >
                    <Features
                        features={ features }
                        onTrack={ onTrack }
                    />
                </ReactObserverWrapper>
            </div>
        );
    }

    hideCfModule = hide => {
        this.setState({ hideCFWidget: hide });
    };

    renderConsumerFinancing = () => {
        const { item: { price } = {}, recordItemImpressions, onTrack, config, user } = this.props;
        const siteCode = config.get('siteCode');
        const isCocoUser = user?.dealer?.car?.dealer_type === USER_TYPE.COCO;
        const renderCFWidget = () => {
            if (config.get('consumerFinance')?.adpv) {
                if (siteCode === 'olxtr') {
                    return isCocoUser ? CFWidgetAsync : null;
                }
                return CFWidgetAsync;
            }
            return null;
        };
        const AsyncCFWidget = renderCFWidget();

        return AsyncCFWidget ? this.panels.includes(DYNAMIC_PANELS.CONSUMER_FINANCING)
            && price
            && price.value
            && !this.state.hideCFWidget
            && <div ref={ this.consumerFinancingPanelRef } className={ css.whiteCard }>
                <ReactObserverWrapper
                    navBarItemId={ NAVBAR_ITEMS.CONSUMER_FINANCING }
                    impression={ DYNAMIC_PANELS.CONSUMER_FINANCING }
                    recordItemImpressions={ recordItemImpressions }
                    setSelectedTabId={ this.setSelectedTabId } >
                    <InView as="div" onChange={ this.handleConsumerFinanceWidget }>
                        <AsyncCFWidget
                            carValue={ price.value.raw }
                            formattedCarValue={ price.value.display }
                            currencySymbol={ price.value.currency }
                            widgetInView={ this.state.cfWidgetInView }
                            config={ this.props.config }
                            item={ this.props.item }
                            dealer={ this.props.user }
                            eventType={ EXPONEA_EVENT_TYPES.CF_SUBMIT }
                            onTrack={ onTrack }
                            page={ 'ADPV' }
                            hideCfModule={ this.hideCfModule }
                            theme={ config.get('theme', 'id') }
                        />
                    </InView>
                </ReactObserverWrapper>
            </div> : null;
    }

    renderBasicAttributes = () => {
        const { item, showNewDesign, onSetFireMakeOffer, isMyItem, showOfferOnAdpv, adpvTxnRevamp, config, user, isShowCoachMark, onCloseMarkCoach, isShowReservationButton, isItemReserved, isOlxMobbi, escrowTrack } = this.props;
        const showAttributes = this.panels.includes(DYNAMIC_PANELS.ATTRIBUTES);
        const actionButtons = adpvTxnRevamp ? this.renderCTAs() : null;
        const newVasBanner = config.get('olxAutos', 'newVasBanner');
        const monthly_installment = item && item.price && item.price.value && item.price.value.emi && item.price.value.emi.monthly_installment && item.price.value.emi.monthly_installment.display ? item.price.value.emi.monthly_installment.display : '0';
        const tenure = item && item.price && item.price.value && item.price.value.emi && item.price.value.emi.tenure ? item.price.value.emi.tenure : 0;
        const down_payment = item && item.price && item.price.value && item.price.value.emi && item.price.value.emi.down_payment && item.price.value.emi.down_payment.display ? item.price.value.emi.down_payment.display : '0';
        const hasPromotion = item && item.has_promotion ? item.has_promotion : false;
        const discountedPriceDisplay = item && item.price && item.price.value && item.price.value.discounted_price && item.price.value.discounted_price.display ? item.price.value.discounted_price.display : '0';
        const discountedPriceValue = item && item.price && item.price.value && item.price.value.discounted_price && item.price.value.discounted_price.raw ? item.price.value.discounted_price.raw : 0;
        const discountAmountDisplay = item && item.price && item.price.value && item.price.value.discount_amount && item.price.value.discount_amount.display ? item.price.value.discount_amount.display : '0';
        const discountAmountValue = item && item.price && item.price.value && item.price.value.discount_amount && item.price.value.discount_amount.raw ? item.price.value.discount_amount.raw : 0;

        if (showAttributes) {
            const displayPrice = item.price && item.price.value ? item.price.value.display : '';
            const priceValue = item.price && item.price.value ? item.price.value.raw : 0;
            const dealerType = user.dealer && user.dealer.car.dealer_type ? user.dealer.car.dealer_type : '';
            const priceCurrency = item.price && item.price.value ? {
                pre: item.price.value.currency.pre,
                post: item.price.value.currency.post
            } : {};

            return (
                <div className={ css.whiteCard }>
                    {/* OLX/Desktop/ADP/PriceCard */}
                    <PriceCard
                        displayPrice={ displayPrice }
                        currencySymbol={ priceCurrency }
                        priceValue={ priceValue }
                        onConsumerFinancingLinkClick={ this.handleTapOnConsumerFinancingLink }
                        siteCode={ this.props.config.get('siteCode') }
                        showNewDesign={ showNewDesign }
                        onSetFireMakeOffer={ onSetFireMakeOffer }
                        enableEmiFeature={ this.enableEmiFeature }
                        isMyItem={ isMyItem }
                        showMakeOffer={ showOfferOnAdpv }
                        actionButtons={ actionButtons }
                        item={ this.props.item }
                        brandPromise={ newVasBanner && this.renderVasBanner() }
                        monthly_installment={ monthly_installment }
                        tenure={ tenure }
                        down_payment={ down_payment }
                        dealerType={ dealerType }
                        hasPromotion={ hasPromotion }
                        discountedPriceDisplay={ discountedPriceDisplay }
                        discountedPriceValue={ discountedPriceValue }
                        discountAmountDisplay={ discountAmountDisplay }
                        discountAmountValue={ discountAmountValue }
                        isShowCoachMark={ isShowCoachMark }
                        onCloseMarkCoach={ onCloseMarkCoach }
                        isShowReservationButton={ isShowReservationButton && !this.isCocoFofoUser && !isOlxMobbi }
                        isItemReserved={ isItemReserved }
                        categoryId={ item.category_id }
                        primaryCTA={ this.primaryCTA }
                        ctaConfigSetup={ this.ctaConfigSetup }
                        escrowTrack={ escrowTrack }
                    />
                </div>
            );
        }
        return null;
    }

    setSelectedTabId = (tabId, removeKey = false) => {
        const idx = this.inViewTabs.indexOf(tabId);

        if (removeKey && idx !== -1) {
            this.inViewTabs.splice(idx, 1);
        }
        else if (!removeKey && idx === -1) {
            this.inViewTabs.push(tabId);
        }

        const tabIdToFocus = Math.min(...this.inViewTabs);
        const isTabOutOfView = this.inViewTabs.length > 0 && this.inViewTabs.indexOf(this.state.selectedTabId) === -1;

        if (isTabOutOfView || this.state.selectedTabId > tabIdToFocus) {
            this.setState({
                selectedTabId: tabIdToFocus
            });
        }
    }

    renderImage = (fileName, size = XX, className = '', alt = '', mode = MODE.LIGHT) => {
        return (<ImageWrapper
            fileName={ fileName }
            fileSize={ size }
            className={ className }
            alt={ alt }
            mode={ mode }
            types={ WEBP_SVG_TYPE } />);
    }

    renderOverview = () => {
        const { item, recordItemImpressions, showNewDesign } = this.props;

        const isCarStoreInspected = getIsStoreInspectedCar(item.inspection_info);
        const showInspectionTag = isCarStoreInspected && showNewDesign;

        return this.panels.includes(DYNAMIC_PANELS.ATTRIBUTES) && (
            <div ref={ this.overviewRef }
                className={ classNames(css.whiteCard, {
                    [css.inspectionTagWrapper]: showInspectionTag
                }) }
                data-aut-id="overviewDetails">
                <ReactObserverWrapper
                    navBarItemId={ NAVBAR_ITEMS.OVERVIEW }
                    impression={ DYNAMIC_PANELS.OVERVIEW }
                    recordItemImpressions={ recordItemImpressions }
                    setSelectedTabId={ this.setSelectedTabId }>
                    <AdOverview item={ item } showInspectionTag={ showInspectionTag } />
                </ReactObserverWrapper>
            </div>
        );
    }

    renderSwapWidget = () => {
        const { recordItemImpressions, item, user, onTrack } = this.props;

        return this.panels.includes(DYNAMIC_PANELS.SWAP_CARS) && (
            <div ref={ this.swapWidgetRef } className={ css.whiteCard }>
                <ReactObserverWrapper
                    onChange={ this.onSwapWidgetView }
                    navBarItemId={ NAVBAR_ITEMS.SWAP_WIDGET }
                    impression={ DYNAMIC_PANELS.SWAP_CARS }
                    recordItemImpressions={ recordItemImpressions }
                    triggerOnce
                    setSelectedTabId={ this.setSelectedTabId } >
                    <SwapWidgetAsync
                        item={ item }
                        dealer={ user }
                        eventType={ EXPONEA_EVENT_TYPES.SWAP_SUBMIT }
                        onTrack={ onTrack }
                    />
                </ReactObserverWrapper>
            </div>
        );
    }

    renderMeetingDetailsBanner = () => {
        const { item } = this.props;
        const { id: itemId, user_id, reserve } = item;
        const loggedInUser = Auth?.getUser()?.id;

        return ((this.showAdpIntentCTAs && loggedInUser) ? (<MeetingBanner
            itemId={ itemId }
            itemUserId={ user_id }
            userId={ loggedInUser }
            reservationData={ reserve }
        />)
            : null
        );
    }

    renderActionButtons = showInspectionConsentCTA => {
        const showFavBtn = !this.props.isMyItem && (this.adpvConfig?.showFavBtn || this.props.featureFlag === LQ_SHORTLIST_FEATURE);
        const showShareBtn = !showInspectionConsentCTA && this.adpvConfig?.showSocialShareBtn;
        const containerClass = this.props.adpvTxnRevamp ? css.actionBtnContainer : css.galleryActionBtnContainer;

        return (<RenderActionButtons
            containerClass={ containerClass }
            showFavBtn={ showFavBtn }
            btnColor={ !this.props.adpvTxnRevamp ? WHITE_TEXT : '' }
            showShareBtn={ showShareBtn }
            { ...this.props }
        />);
    }

    renderAdBasicAttributesCard = () => {
        const { item, user, isMyItem, config } = this.props;
        const { inspection_info } = item;
        const showInspectionConsentCTA = isMyItem && inspection_info && inspection_info.consent === INSPECTION_INFO_STATUS.PENDING;
        const newVasBanner = config.get('olxAutos', 'newVasBanner');

        return (
            <div data-aut-id="carDetailInfo" className={ classNames(css.whiteCard, css.firstCard, { [css.newVasDesign]: newVasBanner }) }>
                {this.renderMeetingDetailsBanner()}
                <AdBasicAttributes
                    item={ item }
                    user={ user }
                >
                    { this.props.adpvTxnRevamp ? this.renderActionButtons(showInspectionConsentCTA) : null}
                </AdBasicAttributes>
            </div>
        );
    }

    renderVasBanner = () => {
        const { user, item, openModal } = this.props;
        const vasClickedTrackingPayload = {
            select_from: FLOW_TYPE.ADPAGE,
            flow_step: FLOW_TYPE.ADPAGE,
            item_id: item.id
        };

        return (
            <div data-aut-id="vas-tags-banner" className={ css.cardBrand }>
                <BrandPromise
                    user={ user }
                    item={ item }
                    onVasTagTap={ openModal }
                    vasClickedTrackingPayload={ vasClickedTrackingPayload }
                    isNewUspVasDesign
                    isAdPage
                />
            </div>

        );
    }

    renderInspectionDetails = () => {
        const { item, isFullItem, onTrack, loggedUser, adpvTxnRevamp, featureFlag, config, carId, itemId, parameters, user, isOlxMobbi } = this.props;
        const isCarStoreInspected = getIsStoreInspectedCar(item.inspection_info);
        const isMXCL = config.get('olxAutos', 'isMXCL');
        const showFavBtnTxn = featureFlag === LQ_SHORTLIST_FEATURE && isMXCL;
        const { showTradeInForm } = this.state;
        const closeTradeInForm = () => this.setState({ showTradeInForm: false });
        const isTradeInFFEnabled = config.get('enableTradeIn');
        const isMobilBekas = config.get('adpvAuto', 'carCategory') === '198';

        return (
            <div className={ css.leftPanel } data-aut-id="leftPanel">
                {adpvTxnRevamp && this.renderImageGallery()}
                {this.renderAdBasicAttributesCard()}
                {this.renderOverview()}
                {!isCarStoreInspected && this.renderAdDescription()}
                {this.renderIRReport()}
                {this.renderTechnicalReportPanel()}
                {isTradeInFFEnabled && this.renderExchangeBanner()}
                {showTradeInForm && <TradeInFormAsync
                    // eslint-disable-next-line react/jsx-no-bind
                    adDetails={ getAdDetails(carId, itemId, item, parameters, user) }
                    selectFrom={ TrackerOrigins.ITEM_PAGE }
                    // eslint-disable-next-line react/jsx-no-bind
                    onClose={ closeTradeInForm }
                />}
                {this.renderFeaturesPanel()}
                {this.renderConsumerFinancing()}
                {this.renderSwapWidget()}
                {isFullItem && !isOlxMobbi && (
                    <AsyncRelatedAdsMX
                        className={ css.whiteCard }
                        item={ item }
                        onTrack={ onTrack }
                        loggedUser={ loggedUser }
                        isOlxMobbi={ isOlxMobbi }
                        onViewRelatedAd={ this.props.onViewRelatedAd }
                        showFavBtn={ showFavBtnTxn }
                        isAdPostedByPremiumUser={ checkUserMembership(user?.subscription_info?.type) || !!this.isCocoFofoUser }
                        getPreferredOrSimilarAdsForPremiumUser={ true }
                        vwoClientInstance={ this.props.vwoClientInstance }
                    />
                )}
                {isFullItem && (
                    <AsyncRelatedAdsMX
                        className={ css.whiteCard }
                        item={ item }
                        onTrack={ onTrack }
                        loggedUser={ loggedUser }
                        isOlxMobbi={ isOlxMobbi }
                        onViewRelatedAd={ this.props.onViewRelatedAd }
                        showFavBtn={ showFavBtnTxn }
                        vwoClientInstance={ this.props.vwoClientInstance }
                    />
                )}
                {(isOlxMobbi || (isMobilBekas && !isOlxMobbi)) && <AsyncRelatedArticles className={ css.whiteCard } parameters={ parameters } />}
            </div>
        );
    }

    renderAdDescription = () => {
        const { item } = this.props;

        return (
            <AdDescription
                description={ item.description }
                onTrack={ this.props.onTrack }
                itemUserId={ item.user_id }
                itemId={ item.id }
                itemStatus={ item.status }
                leadFormName={ this.props.leadFormName }
                leadFormFlow={ this.props.leadFormFlow }
                toggleFirstTimeUserTips={ this.props.toggleFirstTimeUserTips }
                tipsInitiationPoint={ this.props.tipsInitiationPoint }
                onMessageSend={ this.props.onMessageSend }
                isFullItem={ this.props.isFullItem }
            />
        );
    }

    toggleLeadFormSuccessMsg = () => {
        if (this.state.showThankYou) {
            this.props.closeLead();
            this.props.setLeadFormHash('');
            this.props.closeMissedReserve();
        }

        this.setState(
            ({ showThankYou }) => ({ showThankYou: !showThankYou })
        );
    }

    toggleNewLeadGenForm = () => {
        if (!this.state.isNewLeadGenFormOpen) {
            let itemToLeadsMapping = getSessionItem(EXPONEA_EVENT_TO_KEY_MAP.b2c_carSubmitLead);

            itemToLeadsMapping = (itemToLeadsMapping) ? JSON.parse(itemToLeadsMapping) : {};

            const sessionKey = this.props.item?.id ?? '';

            if (sessionKey in itemToLeadsMapping) {
                this.setState(
                    ({ showThankYou }) => ({ showThankYou: !showThankYou })
                );
                return;
            }
        }
        if (this.state.isLoginMandatory && !Auth.isLoggedIn()) {
            this.props.setLoginModalState({
                state: true,
                callback: () => {
                    this.toggleNewLeadGenForm();
                }
            });
        }
        else {
            this.setState(
                ({ isNewLeadGenFormOpen }) => ({ isNewLeadGenFormOpen: !isNewLeadGenFormOpen }),
                () => {
                    if (this.state.isNewLeadGenFormOpen) {
                        const trackLeadType = (this.state.leadFormAction[0] == 'onNotifyMeTap') ? 'notify_me' : 'request_call_back';

                        this.props.onTrack(ADPV_EVENTS.ITEM_TAP_INTERESTED, {
                            item_id: this.props.item.id,
                            chosen_option: trackLeadType,
                            ...LayoutHelper.getAcquisitionChannelTrackingValues()
                        });
                        this.props.onTrack(ADPV_EVENTS.LEAD_FORM_OPEN, {
                            item_id: this.props.item.id,
                            chosen_option: trackLeadType,
                            origin: (this.props.trackSelectFrom == TrackerOrigins.GET_STARTED) ? TrackerOrigins.GET_STARTED : TrackerOrigins.DIRECT,
                            flow_type: this.props.trackOrigin,
                            field_name: trackLeadType,
                            ...LayoutHelper.getAcquisitionChannelTrackingValues()
                        });
                    }
                    else {
                        this.props.closeLead();
                        this.props.setLeadFormHash('');
                        this.props.onTrack(ADPV_EVENTS.AD_PAGE_DIALOG_DISMISS, {
                            select_from: this.userFormState === USERFORM_STATES.THANK_YOU ? USERFORM_STATES.THANK_YOU : USERFORM_STATES.SHOW_INTEREST,
                            item_id: this.props.item.id,
                            ...LayoutHelper.getAcquisitionChannelTrackingValues()
                        });
                    }
                }
            );
        }
    }

    handleLeadFormSubmitComplete = (data, eventType = 'b2c_carSubmitLead') => {
        const { name, email, phone, userId } = data?.leadInfo ?? {};
        const { intl, landingURL } = this.props;
        const campaignParams = { ...getCampaignParams(landingURL) };
        const trackLeadSource = (this.state.leadFormAction[0] == 'onNotifyMeTap') ? LEAD_GEN_SOURCES.NOTIFY_ME : LEAD_GEN_SOURCES.SHOW_INTEREST;
        const trackLeadType = (this.state.leadFormAction[0] == 'onNotifyMeTap') ? 'notify_me' : 'request_call_back';

        let itemLeadMap = getSessionItem(EXPONEA_EVENT_TO_KEY_MAP.b2c_carSubmitLead);

        itemLeadMap = (itemLeadMap) ? JSON.parse(itemLeadMap) : {};

        if (this.props.item && this.props.item.id) {
            itemLeadMap[this.props.item.id] = true;
        }

        setSessionItem(EXPONEA_EVENT_TO_KEY_MAP[eventType], JSON.stringify(itemLeadMap));

        this.props.sendChatMessage(
            intl.formatMessage({ id: 'loginLead' }, { name, phone }),
            this.props.user?.id,
            this.props.item.id,
            'chat',
            {},
            () => { },
            {
                leadFormType: this.state.AsyncleadFormName,
                email,
                phone,
                name,
                ...campaignParams
            },
            {
                leadFormType: this.state.AsyncleadFormName,
                email,
                phone,
                name
            }
        );

        this.props.onTrack(LEAD_FORM_SUBMIT, {
            user_id: Auth?.isLoggedIn() ? Auth.getUser()?.id : userId,
            flow_type: this.props.trackOrigin,
            origin: (this.props.trackSelectFrom == TrackerOrigins.GET_STARTED) ? TrackerOrigins.GET_STARTED : TrackerOrigins.DIRECT,
            chosen_option: trackLeadType,
            select_from: trackLeadSource,
            item_id: this.props.item.id,
            resultset_id: CookieManager.readCookie('__exponea_etc__'),
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        });
        this.toggleLeadFormSuccessMsg();
    }

    openLeadFormV2 = () => {
        const ctaName = getCtaName(this.state.leadFormAction[0]);
        const adpFinanceTabTrackingInfo = getTrackingAttributes(this.props.item?.id);

        this.props.onTrack(ADPV_EVENTS.ITEM_TAP_INTERESTED, {
            item_id: this.props.item.id,
            flow_step: FLOW_TYPE.ADPAGE,
            flow_type: FLOW_TYPE.ADPAGE,
            chosen_option: ctaName,
            select_from: ctaName,
            ...adpFinanceTabTrackingInfo,
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        });
        this.props.setLeadFormV2State({
            show: true,
            adId: this.props.item.id,
            sellerId: this.props.item.user_id,
            leadFormAction: this.state.leadFormAction[0],
            selectFrom: FLOW_TYPE.ADPAGE,
            shouldAddEmiDetails: true,
            actionCallback: data => {
                this.handleLeadFormV2Complete(data);
            }
        });
    }

    handleLeadFormV2Complete = data => {
        const { name, email, phone, leadId, leadFormName, extras } = data ?? {};
        const { intl, landingURL } = this.props;
        const campaignParams = { ...getCampaignParams(landingURL) };

        this.props.sendChatMessage(
            intl.formatMessage({ id: 'loginLead' }, { name, phone }),
            this.props.user?.id,
            this.props.item.id,
            'chat',
            {},
            () => { },
            {
                leadFormType: leadFormName,
                email,
                phone,
                name,
                ...campaignParams
            },
            {
                leadFormType: leadFormName,
                email,
                phone,
                name,
                leadId,
                ...(extras ? { extras: JSON.stringify(extras) } : null)
            }
        );
    }

    handleCTATap = () => {
        this.handleTagTap(NAVBAR_ITEMS.TECHNICAL_REPORT, -BREADCRUMB_HEIGHT);
    }

    renderCTAs = () => {
        const { item, onSetFireMakeOffer, fireMakeOffer, showNewDesign } = this.props;
        const { id: itemId, status: itemStatus, user_id } = item;
        const loggedInUser = Auth?.getUser()?.id;
        const ActionButtons = this.showAdpIntentCTAs ? IntentButtons : ContactInfo;

        return (<ActionButtons
            showCtas={ itemStatus && itemStatus.status === adStatus.ACTIVE }
            toggleFirstTimeUserTips={ this.props.toggleFirstTimeUserTips }
            onMessageSend={ this.props.onMessageSend }
            tipsInitiationPoint={ this.props.tipsInitiationPoint }
            onTrack={ this.props.onTrack }
            leadFormName={ this.props.leadFormName }
            leadFormFlow={ this.props.leadFormFlow }
            buttonContactType="primary"
            itemId={ itemId }
            itemUserId={ user_id }
            userId={ loggedInUser }
            showNewDesign={ showNewDesign }
            onSetFireMakeOffer={ onSetFireMakeOffer }
            fireMakeOffer={ fireMakeOffer }
            showSeePhoneNumber={ this.props.showIvrNumberOnAdpv }
            showCallRequest={ this.props.showRequestCallbackOnAdpv }
            showInterest={ this.props.showInterestOnAdpv }
            showChat={ this.props.showChatOnAdpv }
            showCall={ this.props.showCallOnAdpv }
            showMakeOffer={ this.props.showOfferOnAdpv }
            showTestDrive={ this.props.showStoreTestdriveOnAdpv }
            showStoreVisit={ this.props.showStoreVisitOnAdpv }
            showReserve={ this.props.showReserve }
            showWhatsAppCTA={ this.props.showWhatsAppCTA }
            reserveData={ item?.reserve }
            onClickHandler={ this.showNewLeadForm ? this.openLeadFormV2 : this.toggleNewLeadGenForm }
            setLeadFormType={ this.setLeadFormType }
            trackLeadImpression={ this.trackLeadImpression }
            item={ item }
            vwoClientInstance={ this.props.vwoClientInstance }
            ctaConfigSetup={ this.ctaConfigSetup }
            primaryCTA={ this.primaryCTA }
            isShowCoachMark={ this.props.isShowCoachMark }
            onCloseMarkCoach={ this.props.onCloseMarkCoach }
            isShowReservationButton={ this.props.isShowReservationButton }
            isItemReserved={ this.props.isItemReserved }
            categoryId={ this.props?.item?.category_id }
            escrowTrack={ this.props.escrowTrack }
        />);
    }

    renderBasicDetails = () => {
        const { item, user, getTrackingInfo, onTrack, showNewDesign, config, adpvTxnRevamp, openModal } = this.props;
        const {
            dealer: {
                car: { dealer_type: userType } = {}
            } = {}
        } = user;
        const isMXCL = config.get('olxAutos', 'isMXCL');
        const showInternalID = config.get('olxAutos', 'showInternalID');
        const isCarStoreInspected = getIsStoreInspectedCar(item.inspection_info);
        const ReportAdComponent = isMXCL ? ReportAdMX : ReportAd;
        const actionButtons = !adpvTxnRevamp ? (<>
            {!showNewDesign && <div className={ css.separator } /> }
            <div className={ css.callToActions } >
                {this.renderCTAs()}
            </div>
        </>) : null;
        const newVasBanner = config.get('olxAutos', 'newVasBanner');

        const getVwoTrackingInfo = () => {
            const user = Auth?.getUser();
            const options = {
                eventProperties: {
                    user_id: user ? user.id : 'na',
                    this_ad_title: item.title ? item.title : 'na',
                    this_ad_id: item.id ? item.id : 'na',
                    ad_owner_user_id: item.user_id ? item.user_id : 'na',
                    is_this_ad_with_video: item.is_video_generated ? item.is_video_generated : false
                }
            };

            this.props.vwoClientInstance.track(AI_VIDEO_ADS_CAMPAIGN_ID.DESKTOP, 'adpv_view_profile_click', options);
        };

        return (
            <div className={ css.rightPanel } data-aut-id="rightPanel">
                <div className={ css.whiteCard } data-aut-id="priceSection">
                    {this.renderBasicAttributes()}
                    { !newVasBanner && <VasTagsClass
                        itemId={ item.id }
                        vasValues={ item.value_added_services }
                        gradient={ isCocoFofoUser(userType) ? MONETIZATIONDARK1 : BLACKBACKGROUND2 }
                        onTrack={ onTrack }
                        onVasTagTap={ openModal } />}
                </div>
                <SellerInfo
                    item={ item }
                    escrowDetails={ this.props.escrowDetails }
                    user={ user }
                    getTrackingInfo={ getTrackingInfo }
                    onTrack={ onTrack }
                    isMyItem={ this.props.isMyItem }
                    adpvTxnRevamp={ this.props.adpvTxnRevamp }
                    actionButtons={ this.props.adpvTxnRevamp ? null : actionButtons }
                    getVwoTrackingInfo={ getVwoTrackingInfo }
                />
                {this.props.renderBanners('middle')}
                { !newVasBanner && isCocoFofoUser(userType) && <BrandPromiseCoco user={ this.props.user } /> }
                {isCarStoreInspected && this.renderAdDescription()}
                <div className={ css.monetizationCard }>
                    {this.props.getMonetizerCard()}
                    {this.props.getLimitsCard('desktop')}
                </div>
                {!this.props.isMyItem && (
                    <div className={ css.reportAd }>
                        <ReportAdComponent
                            itemId={ this.props.item.id }
                            internalId={ showInternalID && this.props.item.internalId }
                            onClick={ this.props.onClickReport } />
                    </div>
                )}
                { this.props.renderBanners('middle-bottom') }
                { this.props.renderBanners('bottom') }
            </div>
        );
    }

    renderImageGallery = () => {
        const { item, isMyItem, isItemOutdated, mainGalleryImages, onTrack, config } = this.props;
        const { inspection_info, inspectionDetails: { damageReport } = {}} = item;

        const showGallery = mainGalleryImages.length > 0
            && parseInt(mainGalleryImages[0].id, 10) !== 1;
        const showInspectionConsentCTA = isMyItem && inspection_info && inspection_info.consent === INSPECTION_INFO_STATUS.PENDING;
        const disableImgOptimization = !!config.get('disableImgOptimization');
        const isVideoGenerated = item && item.is_video_generated ? item.is_video_generated : false;
        const videoUrl = item && item.video_url ? item.video_url : '';

        return (
            <React.Fragment>
                {
                    showGallery
                    && <div className={ css.imageGalleryWrapper }>
                        <ReactObserver rootMargin={ `-${HEADER_OFFSET / 2}px 0px 0px` }>
                            {({ inView, ref, entry }) => {
                                if (entry && inView && this.state.basicInfoInView) {
                                    this.setState({ basicInfoInView: false });
                                }
                                else if (entry && !inView && !this.state.basicInfoInView) {
                                    this.setState({
                                        basicInfoInView: true,
                                        selectedTabId: 0
                                    });
                                }
                                return (<div ref={ ref } data-aut-id="imageGallery">
                                    <ImageGallery
                                        className={ css.overFlowUnset }
                                        images={ mainGalleryImages }
                                        selectedImgIdx={ this.state.selectedImgIdx }
                                        title={ item.title }
                                        userID={ this.props.user.id }
                                        price={ item.price ? item.price.value.display : '' }
                                        isMyItem={ isMyItem }
                                        isItemOutdated={ isItemOutdated }
                                        itemId={ this.props.item.id }
                                        getTrackingInfo={ this.props.getTrackingInfo }
                                        trackImageTap={ this.props.trackImageTap }
                                        trackImagePagination={ this.props.trackImagePagination }
                                        isPreview={ showInspectionConsentCTA }
                                        fullScreenHash={ ITEM_FULL_SCREEN_HASH }
                                        showFavouriteButton
                                        imageSize="850"
                                        dotSize={ 10 }
                                        showSliderArrows
                                        showThumbsContainer={ false }
                                        showIndex={ false }
                                        updateImageOnChange={ false }
                                        showThumbnails={ true }
                                        disableImgOptimization={ disableImgOptimization }
                                        customSliderCss={ css.customSlider }
                                        isVideoGenerated={ isVideoGenerated }
                                        videoUrl={ videoUrl }
                                        adpvTxnRevamp={ this.props.adpvTxnRevamp }
                                        monetizationInfo={ item.monetizationInfo }
                                    >
                                        {!this.props.adpvTxnRevamp && this.renderActionButtons(showInspectionConsentCTA)}
                                        { damageReport && damageReport.values && !!damageReport.values.length && (
                                            <GalleryNavigationTiles isSpinCarEnabled={ this.props.isSpinCarEnabled }
                                                onTrack={ onTrack }
                                            />
                                        )}
                                    </ImageGallery>
                                </div>);
                            }}
                        </ReactObserver>
                    </div>
                }
            </React.Fragment>
        );
    }

    onWhatsAppClick = e => {
        this.props.onTrack(ADPV_EVENTS.CONTACT_BUTTON_TAP, {
            chosen_option: LEAD_IMPRESSION_FIELD_NAMES.WHATSAPP,
            select_from: TrackerOrigins.ITEM_PAGE,
            flow_type: FLOW_TYPE.ADPAGE
        });
        e.preventDefault();
        window.open(this.whatsAppLink, '_blank');
    };

    getCTAConfigs = () => {
        const {
            showInterestOnAdpv,
            showRequestCallbackOnAdpv,
            showIvrNumberOnAdpv,
            showChatOnAdpv,
            showCallOnAdpv,
            showStoreTestdriveOnAdpv,
            showOfferOnAdpv,
            showWhatsAppCTA,
            isShowReservationButton
        } = this.props;

        this.primaryCTA = '';

        const CTA_CONFIGS = JSON.parse(JSON.stringify(CTA_CONFIGS_MAP)); // CREATING CP OF CONFIGS

        if (showInterestOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_INTEREST_CTA;
            CTA_CONFIGS.SHOW_INTEREST_CTA.isActive = true;
        }
        if (showRequestCallbackOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_CALL_REQUEST_CTA;
            CTA_CONFIGS.SHOW_CALL_REQUEST_CTA.isActive = true;
        }
        if (showIvrNumberOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_SEE_PHONE_NUMBER_CTA;
            CTA_CONFIGS.SHOW_SEE_PHONE_NUMBER_CTA.isActive = true;
        }
        if (showStoreTestdriveOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_TEST_DRIVE_CTA;
            CTA_CONFIGS.SHOW_TEST_DRIVE_CTA.isActive = true;
        }
        if (showCallOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_CALL_CTA;
            CTA_CONFIGS.SHOW_CALL_CTA.isActive = true;
        }
        if (showChatOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_CHAT_CTA;
            CTA_CONFIGS.SHOW_CHAT_CTA.isActive = true;
        }
        if (showOfferOnAdpv) {
            this.primaryCTA = CTA_MAP.SHOW_MAKE_OFFER_CTA;
            CTA_CONFIGS.SHOW_MAKE_OFFER_CTA.isActive = true;
        }
        if (showWhatsAppCTA) {
            this.primaryCTA = CTA_MAP.SHOW_WHATSAPP_CTA;
            CTA_CONFIGS.SHOW_WHATSAPP_CTA.isActive = true;
        }
        if (isShowReservationButton) {
            this.primaryCTA = '';
        }

        return CTA_CONFIGS;
    }

    render() {
        const {
            item,
            intl,
            isGalleryOverlayOpened,
            closeGalleryOverlay,
            onTrack,
            adpvTxnRevamp,
            isShowCoachMark
        } = this.props;

        const { damageReport, technicalReport } = item.inspectionDetails || {};
        const renderGalleryNavTiles = damageReport && damageReport.values && !!damageReport.values.length;
        const showTR = this.panels.includes(DYNAMIC_PANELS.TECHNICAL_REPORT) && technicalReport?.values?.length > 0;
        const isNotifyMe = this.state.leadFormAction[0] === 'onNotifyMeTap';
        const thankYouWidgetProps = getThankYouWidgetProps(this.props.isMissedReserveOpened, isNotifyMe);

        this.ctaConfigSetup = this.getCTAConfigs();

        return (
            <React.Fragment>
                {
                    this.state.basicInfoInView && !isShowCoachMark
                    && <NavBar
                        item={ item }
                        onTagTap={ this.handleTagTap }
                        selectedTabId={ this.state.selectedTabId }
                        showInspectionConsentCTA={ false }
                        { ...this.props }
                    />
                }
                {this.showWhatsApp && <StickyWhatsappButton
                    className={ css.whatsAppAdpv }
                    iconSize={ WHATSAPP.DESKTOP_ICON }
                    iconClassName={ css.whatsAppAdpvIcon }
                    onWhatsAppClick={ this.onWhatsAppClick }
                    whatsAppLink={ this.whatsAppLink }
                />}
                {!adpvTxnRevamp && this.renderImageGallery()}
                {!adpvTxnRevamp && this.state.basicInfoInView
                && <div className={ css.extraPadding } />
                }
                <div className={ classNames(css.panelWrapper,
                    { [css.withoutGalleryNav]: !renderGalleryNavTiles,
                        [css.newLayout]: adpvTxnRevamp }
                ) }>
                    {this.renderInspectionDetails()}
                    {this.renderBasicDetails()}
                </div>
                {this.props.renderBookingModal()}

                { this.state.showThankYou && (
                    <Overlay
                        isOpened
                        onClose={ this.toggleLeadFormSuccessMsg }
                        overlayClassName={ css.overlay }
                    >
                        <div className={ css.modal }>
                            <NewIconButton
                                icon="cross"
                                color="primaryBase"
                                size={ 24 }
                                data-aut-id={ 'closeThankyou' }
                                onClick={ this.toggleLeadFormSuccessMsg }
                                className={ css.userDetailsForm__closeBtn }
                                onChange={ this.toggleLeadFormSuccessMsg }
                            />
                            <ThankYouWidget
                                title={ intl.formatMessage({ id: `${thankYouWidgetProps.title}` }) }
                                subTitle={ intl.formatMessage({ id: `${thankYouWidgetProps.subTitle}` }) }
                                className={ css.thankYou }
                                imgClassName={ css.img }
                                textClassName={ css.textWrapper }
                                imgFilePath={ thankYouWidgetProps.imgURL }
                            />
                        </div>
                    </Overlay>
                )}

                {!this.showNewLeadForm
                && <AsyncItemLeadForm
                    source={ this.state.leadFormAction[0] }
                    className={ css.leadFormContainer }
                    leadFormName={ this.state.AsyncleadFormName }
                    openLeadFormFlow={ this.state.isNewLeadGenFormOpen }
                    optionalAuth
                    actionCallback={ this.handleLeadFormSubmitComplete }
                    item={ item }
                    toggleLeadFormFlag={ this.toggleNewLeadGenForm }
                />}

                {isShowCoachMark && <div>
                    <div className={ css.blockContentUp } />
                </div>}

                { !!this.props.params.sectionId && (
                    <GalleryNavOverlayAsync
                        isGalleryOverlayOpened={ isGalleryOverlayOpened }
                        trackImagePagination={ this.props.trackImagePagination }
                        trackImageTap={ this.props.trackImageTap }
                        onGalleryOverlayClose={ closeGalleryOverlay }
                        damageReport={ damageReport }
                        trName={ technicalReport?.name }
                        showTR={ showTR }
                        onCTATap={ this.handleCTATap }
                        setMainGalleryImgIdx={ this.setMainGalleryImgIdx }
                        isSpinCarEnabled={ this.props.isSpinCarEnabled }
                        onTrack={ onTrack }
                    />
                )}
            </React.Fragment>
        );
    }
}

export const mapStateToProps = (state, ownProps) => ({
    mainGalleryImages: selectAdpvGalleryImages(state, ownProps),
    leadFormConfigData: leadFormConfigSelector(state),
    landingURL: state.track && state.track.landingURLSearch,
    trackOrigin: state.track.origin,
    trackSelectFrom: state.track.selectFrom,
    carId: getCarIdSelector(state, ownProps.item?.id),
    reserve: state.reserve,
    adpvTxnRevamp: ownProps.config.get('adpvAuto').revamped,
    isLeadFormV2ConfigCached: !!Object.keys(state.leadFormV2?.formConfig ?? {}).length,
    fetchConfig: state.leadFormV2?.fetchConfig
});

export const mapDispatchToProps = dispatch => ({
    setOriginTrack: origin => dispatch(setOrigin(origin)),
    setLoginModalState: state => dispatch(_setLoginModalState(state)),
    getCarReserveStatus: (adId, cb) => dispatch(getCarReserveStatus(adId)).then(res => cb && cb(res)),
    resetReserveStateAction: () => dispatch(resetReserveState()),
    setLeadFormV2State: state => dispatch(setLeadFormV2StateAction(state)),
    resetLeadFormV2FetchConfigState: () => dispatch(resetLeadFormV2FetchConfigState())
});

export default compose(
    withConfig,
    injectIntl,
    withRouter,
    withMessage,
    withFeatureFlags,
    withVwo,
    withLQFeatureFlag(LQ_SHORTLIST_FEATURE),
    connect(mapStateToProps, mapDispatchToProps),
    React.memo
)(AdpvMX);
